module.exports = __webpack_public_path__ + "img/api-cube.0c285f27.png";